import { IEntityDto } from "./base";
import { IXenaAppTranslation } from "./xena-app-translation";

export interface IXenaApp extends IEntityDto {
  name?: string;
  description?: string;
  details?: string;
  applicationVisibility?: string;
  iconId?: number;
  category?: string;
  termsMarkdown?: string;
  culture?: string;
  isCountrySpecific?: boolean;
  countryName?: string;
  pricePerFiscal?: number;
  pricePerUser?: number;
  applicationVisibilityTranslated?: string;
  categoryTranslated?: string;
  uri?: string;
  isApproved?: boolean;
  isAwaitingApproval?: boolean;
  cultureDisplayName?: string;
  countryDisplayName?: string;
  translations: { [key: string]: IXenaAppTranslation };
}
